import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const ResetAccount = Loadable(lazy(() => import("./ResetAccount.jsx")));

const ResetAccountRoutes = [
    { path: "/reset-account", element: <ResetAccount/> },
];

export default ResetAccountRoutes;